const certificateButtons = document.querySelectorAll('.view-certificate_button');
certificateButtons?.forEach((each) => {
  each.addEventListener('click', () => {
    const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    if (isiOS) {
      const fileUrl = each.getAttribute('data-certificate-file');
      console.log(fileUrl);
      if (fileUrl) {
        // window.location.href = fileUrl;
        window.open(fileUrl, '_blank');
      }
    } else {
      certificatePopup(each, 'add');
    }
  })
})
const certificateCloseButtons = document.querySelectorAll('.certificate-close__button');
certificateCloseButtons?.forEach((each) => {
  each.addEventListener('click', () => {
    certificatePopup(each, 'remove');
  })
})

function certificatePopup (button, action) {
  const certificateItem = button.closest('.test-certificate-item');
  certificateItem?.classList[action]('active');
  document.querySelector('body')?.classList[action]('certificate-overflow-hidden');
}

document.addEventListener('click', (event) => {
  if (event.target.classList.contains('lab-certificate-popup_wrapper')) {
    certificatePopup(event.target, 'remove');
  }
});

document.querySelectorAll('.lab-test_certification-redirection').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    const targetId = this.getAttribute('href');
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      const headerOffset = 120;
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  });
});
document.querySelectorAll('.lab_test_certification_view').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    const targetId = this.getAttribute('href');
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      const headerOffset = 120;
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  });
});
